import { immerable } from 'immer';

interface IOrganization {
	id: number;
	code: string;
	name: string;
}

const entityDefaults: IOrganization = {
	id: -1,
	code: '',
	name: '',
};

export class Organization implements IOrganization {
	private [immerable] = true;
	public id = entityDefaults.id;
	public code = entityDefaults.code;
	public name = entityDefaults.name;

	public static build(params: Partial<IOrganization> = {}): Organization {
		const inst = new Organization();
		inst.id = params.id ?? entityDefaults.id;
		inst.code = params.code ?? entityDefaults.code;
		inst.name = params.name ?? entityDefaults.name;
		return inst;
	}
}
